module.exports = __webpack_public_path__ + "static/media/ioc.a5a19f03.png";